module.exports = __webpack_public_path__ + "static/img/apple-3.b8cdf7c4.jpg";